"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimAndLowerCase = void 0;

/**
 * remove trailing and leading space of the input string
 * also lower the case
 * @param {string} string - object that you want to work on
 * @return {string}
 */
var trimAndLowerCase = function trimAndLowerCase(string) {
  return string.toLowerCase().trimEnd().trimStart();
};

exports.trimAndLowerCase = trimAndLowerCase;